export default {
  text: '#d4d4d4',
  primary: '#89012C',
  secondary: '#89012C',
  background: '#140c0c',
  backgroundSecondary: 'black',
  light: '#FFF',
  dark: '#020303'
}
